import { render } from "./orderList.vue?vue&type=template&id=3a3f5aee&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=3a3f5aee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3f5aee"]])

export default __exports__